<template>
  <div class="row custom-meal-wrapper">
    <div class="col-md-3 custom-meal-image">
      <a @click="showMealImage">
        <img :src="plan.photoUrl" />
      </a>
    </div>
    <div class="col-md-9">
      <div class="custom-meal-name">{{ plan.name }}</div>
      <div class="custom-meal-date">{{ formatDate(plan.updated_at) }}</div>
      <p>{{ plan.notes }}</p>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'nutrition-mealplan-record',
  props: {
    plan: {
      type: Object,
      default: null,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).local().format('MM/DD/YYYY hh:mm a')
    },
    showMealImage() {
      this.$emit('showMealPlan', this.plan.photoUrl)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-meal-wrapper {
  border-bottom: 1px solid #dee2e6;
  padding: 15px;
}
.custom-meal-image {
  text-align: center;
  cursor: pointer;
  img {
    width: 96px;
  }
}
.custom-meal-name {
  font-size: 1.1em;
  font-weight: 500;
}
.custom-meal-date {
  font-size: 0.8em;
  font-style: italic;
}
</style>
